'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lineChart = require('./lineChart');

var _lineChart2 = _interopRequireDefault(_lineChart);

var _choropleth = require('./choropleth');

var _choropleth2 = _interopRequireDefault(_choropleth);

var _bubble = require('./bubble');

var _bubble2 = _interopRequireDefault(_bubble);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createVisualization = function createVisualization(container, options) {
  switch (options.type) {
    case 'line-chart':
      (0, _lineChart2.default)(container, options.data, options.title);
      break;
    case 'choropleth':
      (0, _choropleth2.default)(container, options.data, options.title, options.showLegend, options.breakGroups, options.colorScheme);
      break;
    case 'bubble':
      (0, _bubble2.default)(container, options.data, options.title);
      break;
    default:
      console.error('no such visualization type');
  }
};

exports.default = createVisualization;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ephtracking-viz/dist/visualizations/index.js
// module id = 792
// module chunks = 0